import { createSelector } from '@reduxjs/toolkit';

import { IApplicationState, WSelector } from '../rootInterface';

const selectPriorityState = (state: IApplicationState) => state.priority;

export const priorityStateSelector = (): WSelector<boolean> =>
  createSelector(selectPriorityState, priorityState => priorityState.priority);
